import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from "@/components/ui/card";
import {
  Globe,
  Users,
  Plus,
  ChevronRight,
  FileText,
  Building2,
} from "lucide-react";
import { API } from "./Sidebar";

export const OverviewPage = () => {
  const [stats, setStats] = useState({
    total_websites: 0,
    active_websites: 0,
    total_leads: 0,
    new_leads: 0,
    total_projects: 0,
  });

  useEffect(() => {
    const fetchStats = async () => {
      try {
        const res = await axios.get(`${API}/stats`);
        setStats(res.data);
      } catch (e) {
        console.error("Failed to fetch stats");
      }
    };
    fetchStats();
  }, []);

  const statCards = [
    { label: "Website Projects", value: stats.total_projects, color: "bg-purple-500", icon: FileText },
    { label: "Total Websites", value: stats.total_websites, color: "bg-blue-500", icon: Globe },
    { label: "Total Leads", value: stats.total_leads, color: "bg-green-500", icon: Users },
    { label: "New Leads", value: stats.new_leads, color: "bg-orange-500", icon: Users },
  ];

  return (
    <div data-testid="overview-page">
      <div className="mb-8">
        <h2 className="text-2xl font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>
          Dashboard Overview
        </h2>
        <p className="text-slate-600 mt-1">Manage your lead generation websites</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
        {statCards.map((stat, index) => (
          <Card key={index} className="border-slate-200" data-testid={`stat-card-${index}`}>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium text-slate-600 flex items-center gap-2">
                <stat.icon className="w-4 h-4" />
                {stat.label}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center space-x-3">
                <div className={`w-3 h-3 rounded-full ${stat.color}`}></div>
                <span className="text-3xl font-bold text-slate-900" style={{ fontFamily: "var(--font-heading)" }}>
                  {stat.value}
                </span>
              </div>
            </CardContent>
          </Card>
        ))}
      </div>

      {/* Quick Actions */}
      <div className="grid md:grid-cols-2 gap-6">
        <Card className="border-slate-200">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <Building2 className="w-5 h-5 text-orange-500" />
              Create New Website
            </CardTitle>
            <CardDescription>
              Build a new lead generation website from scratch
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/admin/builder">
              <Button className="bg-orange-500 hover:bg-orange-600">
                <Plus className="w-4 h-4 mr-2" />
                Start Building
              </Button>
            </Link>
          </CardContent>
        </Card>

        <Card className="border-slate-200">
          <CardHeader>
            <CardTitle className="flex items-center gap-2">
              <FileText className="w-5 h-5 text-blue-500" />
              My Projects
            </CardTitle>
            <CardDescription>
              View and manage your existing website projects
            </CardDescription>
          </CardHeader>
          <CardContent>
            <Link to="/admin/projects">
              <Button variant="outline">
                View Projects
                <ChevronRight className="w-4 h-4 ml-2" />
              </Button>
            </Link>
          </CardContent>
        </Card>
      </div>
    </div>
  );
};
